import * as React from 'react';
import { StyleSheet, ActivityIndicator } from 'react-native';
import AvatarViewer from '../components/AvatarViewer';
import Container from '../components/Container';
import { Text, View } from '../components/Themed';
import { getAuthToken, createAvatar, getRequest } from '../utils/request';

var intervalId: number;

function simulateAvatarGenerating(callback: any) {
    var count = 0;
    intervalId = window.setInterval(function(){
        console.log(count);
        
        if (++count >= 3) {
            clearInterval(intervalId);
            console.log("done");
            callback({ status: "Completed" });
        }
    }, 1000);
}

export default function Result({ route, navigation }) {
    const image = route.params.image;
    const name = route.params.name;
    const [loaded, setLoaded] = React.useState(false);
    const [resp, setResp] = React.useState(null);

    const onGenerate = (name: string, image: any) => {
        // We first need to generate a token
        getAuthToken((token: string) => {
            if (token) {
                console.log(token);
                
                //Once the token is received, send the image to create an avatar
                createAvatar(name, image, token, (resp: any) => {
                    if (resp) {
                        intervalId = window.setInterval(function(){
                            getRequest(resp.url, token, (resp: any) => {
                                if (resp.status == "Completed") {
                                    clearInterval(intervalId);
                                    resp["token"] = token.replace("Bearer ", "");
                                    setResp(resp);

                                    // Important to set the response before loading the Avatar viewer
                                    setLoaded(true);
                                }
                            });
                        }, 5000);
                    }
                });

                // simulateAvatarGenerating((resp: any) => {
                //     if (resp.status == "Completed") {
                //         resp = {
                //             name: name,
                //             mesh: "https://api.avatarsdk.com/avatars/2fb2f320-dd64-4cd2-9dcf-be286c24265c/mesh/",
                //             texture: "https://api.avatarsdk.com/avatars/2fb2f320-dd64-4cd2-9dcf-be286c24265c/texture/",
                //             token: token.match(/(?<=Bearer\s).+/)
                //         };
                //         setResp(resp);
                //         setLoaded(true);
                //     }
                // });
            }
        });
    }

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            onGenerate(name, image);
        });

        navigation.addListener('blur', () => {
            clearInterval(intervalId);
        });
    }, [navigation, name, image]);

    return (
        <Container>
            <View style={{ display: loaded ? 'none' : undefined }}>
                <Text style={styles.text}>Génération / Generating</Text>
                <ActivityIndicator size="large" />
            </View>
            {loaded && <AvatarViewer resp={resp} navigation={navigation}/>}
        </Container>
    );
}

const styles = StyleSheet.create({
    text: {
        fontSize: 17,
        lineHeight: 24,
        margin: 10,
        color: 'rgba(0,0,0,0.8)'
    }
});
